import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { environment } from 'src/environments/environment';

// Default Firebase config as fallback
const DEFAULT_FIREBASE_CONFIG = {
    apiKey: "AIzaSyBVxR3BIo7CQ-lzMvKp-nEfAXYhYcDELno",
    authDomain: "schoolerp-176c3.firebaseapp.com",
    projectId: "schoolerp-176c3",
    storageBucket: "schoolerp-176c3.firebasestorage.app",
    messagingSenderId: "761560068017",
    appId: "1:761560068017:web:4d335a19ac588f13939790",
    measurementId: "G-QBFS0F9LJT"
};

// Synchronously load Firebase config from JSON file
function loadFirebaseConfigSync(): any {
    const configFile = environment.firebaseConfigFile;
    
    try {
        // Use XMLHttpRequest for synchronous loading
        const xhr = new XMLHttpRequest();
        xhr.open('GET', configFile, false); // false = synchronous
        xhr.send();
        
        if (xhr.status === 200) {
            const config = JSON.parse(xhr.responseText);
            return config;
        } else {
            console.warn('⚠️ Failed to load Firebase config from JSON, using default');
            return DEFAULT_FIREBASE_CONFIG;
        }
    } catch (error) {
        console.warn('⚠️ Error loading Firebase config from JSON, using default:', error);
        return DEFAULT_FIREBASE_CONFIG;
    }
}

@NgModule({
    imports: [
        // Initialize AngularFireModule with dynamically loaded config from JSON file
        AngularFireModule.initializeApp(loadFirebaseConfigSync()),
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
        provideFirebaseApp(() => initializeApp(loadFirebaseConfigSync())),
        provideFirestore(() => getFirestore()),
        provideDatabase(() => getDatabase()),
    ],
    providers: []
})
export class FirebaseModule { } 